<template>
  <el-dialog
    :visible.sync="useTermsDialogVisible"
    width="98%"
    top="6vh"
    :show-close="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false">
    <span class="terms_title" slot="title">{{ useTermsTitle }}</span>

    <div class="terms_content" v-html="useTermsContent"></div>

    <div slot="footer">
      <el-button @click="agree" style="width: 100%" type="primary">{{ $t('동의') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      useTermsDialogVisible: false,
      useTermsTitle: '',
      useTermsContent: '',
    }
  },

  computed: {
    ...mapGetters({
      isLogin: 'auth/isLogin',
      auth: 'auth/auth',
      authId: 'auth/authId',
    }),
    shouldShowTerms() {
      if (!this.isLogin) return false

      if (this.authId !== 'storeMng' || this.auth.agreeYn) {
        return false
      }

      return true
    },
  },

  watch: {
    shouldShowTerms: {
      handler(val) {
        if (val) {
          this.showTerms()
          this.useTermsDialogVisible = true
        }
      },
      immediate: true,
    },
  },

  methods: {
    async showTerms() {
      const result = await this.$axios.get('/api/getTerms/ko/UseTerms').then((res) => res.data)

      this.useTermsTitle = result.termsTitle
      this.useTermsContent = result.content
    },
    async agree() {
      const storeId = this.$store.state.storeId
      const result = await this.$axios.post(`/agree/${storeId}`).then((res) => res.data)

      this.useTermsDialogVisible = false
      location.reload()
    },
  },
}
</script>

<style scoped>
.terms_content {
  height: calc(100vh - 300px);
}
</style>
